import * as PatientListV4I from "./sequence/PatientListV4";
import * as QueueDomainI from "./queueDomainV4";
import * as ExamV4I from "./sequence/ExamV4";
import * as ExamDispatchI from "../patient/examDispatchV4";
import * as PatientOrdersV4I from "./sequence/PatientOrdersV4";
import * as MultidisciplinaryV4I from "./sequence/MultidisciplinaryV4";
import * as OrderSheetV4I from "./sequence/OrderSheetV4";
import * as OrderAppointmentV4I from "./sequence/OrderAppointmentV4";
import * as ResultSummaryV4I from "./sequence/ResultSummaryV4";
import * as PatientHistoryV4I from "./sequence/PatientHistoryV4";
import * as RegistrationV4I from "./sequence/RegistrationV4";
import * as TeleHealthV4I from "./sequence/TeleHealthV4";
import * as PackageV4I from "./sequence/PackageV4";

/* ------------------------------------------------------ */

/*          PatientListV4 sequence (interface)            */

/* ------------------------------------------------------ */

/**
 * ชื่อ sequence ที่ใช้เรียกผ่าน RunSequence
 */
export const PATIENT_LIST_V4_SEQUENCE = PatientListV4I.SEQUENCE_NAME;
export const PATIENT_LIST_V4_CARD = PatientListV4I.CARD_NAME;
export const PATIENT_LIST_V4_ACTIONS = PatientListV4I.ACTIONS;
/** key ของ state.buttonLoadCheck เช่น CardPatientListV4_SEARCH */
export const PATIENT_LIST_V4_BTN_ACTS = PatientListV4I.BTN_ACTS;

export type PatientListV4Filter = PatientListV4I.FilterType;
export type PatientListV4Event = PatientListV4I.Event;
export type PatientListV4SequenceState = PatientListV4I.State["PatientListV4Sequence"];
export type PatientListV4Slice = PatientListV4I.PatientListV4Slice;
/** ผล/audit ของการเปลี่ยนสถานะปุ่ม "ส่งต่อ" (แถบข้อความเหนือตารางคิว) */
export type QueueTransitionInfo = PatientListV4I.QueueTransitionInfo;
/** แถว Encounter ดิบจาก encounter-patient-optimized */
export type RawQueueEncounter = PatientListV4I.RawQueueEncounter;
export type OnEvent = PatientListV4I.OnEvent;

/**
 * params ที่ CardPatientListV4 ต้องส่งให้ runSequence
 * (team practice: card เรียก props.runSequence({ sequence, action, card, ...filter })
 *  ดู patient/CardOrdersV4.tsx:137-162 — helper ประกอบ event ใน UI ถูกถอดออกแล้ว)
 */
export type PatientListRunParams = PatientListV4I.PatientListRunParams;
export type PatientListRunSequenceProp = PatientListV4I.PatientListRunSequenceProp;

/** function ที่ main app (MainHIS) supply ให้ card (this.runSequence) */
export type RunSequence = PatientListV4I.RunSequence;

/** re-export types ของ sequence state สำหรับ merge เข้า MainState */
export type PatientListV4State = PatientListV4I.State;
export type PatientListV4Data = PatientListV4I.Data;
export type PatientListV4Props = PatientListV4I.Props;

/* ------------------------------------------------------ */

/*            ExamV4 sequence (หน้าตรวจรักษา)              */

/* ------------------------------------------------------ */

export const EXAM_V4_SEQUENCE = ExamV4I.SEQUENCE_NAME;
export const EXAM_V4_CARD = ExamV4I.CARD_NAME;
/** card ที่เป็นผู้ส่ง action ของ ExamV4 (doctor / gallery / nursing) */
export const EXAM_V4_CARDS = ExamV4I.CARD_NAMES;
export const EXAM_ACTIONS = ExamV4I.ACTIONS;
/** key ของ state.buttonLoadCheck เช่น CardGalleryV4_LOAD_GALLERY */
export const EXAM_V4_BTN_ACTS = ExamV4I.BTN_ACTS;
export const ACTION_START_EXAM = ExamV4I.ACTION_START_EXAM;

/** slice เดียวกับ state.ExamV4Sequence ที่ MainHIS ส่งลงมาให้ card */
export type ExamV4SequenceState = ExamV4I.State["ExamV4Sequence"];
export type ExamV4SliceState = ExamV4I.State["ExamV4Sequence"];
export type ExamV4ActionName = ExamV4I.ActionName;
/** params ที่ card ต้องส่งให้ runSequence */
export type ExamRunParams = ExamV4I.ExamRunParams;
export type ExamRunSequence = ExamV4I.RunSequence;
export type ExamV4Event = ExamV4I.Event;
export type ExamV4State = ExamV4I.State;
export type ExamV4Data = ExamV4I.Data;

/** key helper เดียวกับ CommonInterface.SetErrorMessage (card ใช้ตรวจ loading/error) */
export const examBtnKey = ExamV4I.examBtnKey;
export const examErrorKey = ExamV4I.examErrorKey;

export { ExamV4I, ExamDispatchI };

/* ------------------------------------------------------ */

/*   MultidisciplinaryV4 (บันทึกทีมสหสาขาของหน้าบันทึกการพยาบาล)   */

/* ------------------------------------------------------ */

export const CONSULT_V4_SEQUENCE = MultidisciplinaryV4I.SEQUENCE_NAME;
export const CONSULT_V4_CARD = MultidisciplinaryV4I.CARD_NAME;
export const CONSULT_ACTIONS = MultidisciplinaryV4I.ACTIONS;
/** key ของ state.buttonLoadCheck เช่น CardMultidisciplinaryV4_CREATE */
export const CONSULT_V4_BTN_ACTS = MultidisciplinaryV4I.BTN_ACTS;

export type ConsultV4SequenceState = MultidisciplinaryV4I.State["MultidisciplinaryV4Sequence"];
export type ConsultV4ActionName = MultidisciplinaryV4I.ActionName;
export type ConsultRunParams = MultidisciplinaryV4I.ConsultRunParams;
export type ConsultRunSequence = MultidisciplinaryV4I.RunSequence;
export type ConsultV4Event = MultidisciplinaryV4I.Event;
export type ConsultV4State = MultidisciplinaryV4I.State;
export type ConsultV4Data = MultidisciplinaryV4I.Data;

export const consultBtnKey = MultidisciplinaryV4I.consultBtnKey;
export const consultErrorKey = MultidisciplinaryV4I.consultErrorKey;

export { MultidisciplinaryV4I };

/* ------------------------------------------------------ */

/*   ResultSummaryV4 (หน้า Result Summary)                 */

/* ------------------------------------------------------ */

export const RESULT_SUMMARY_V4_SEQUENCE = ResultSummaryV4I.SEQUENCE_NAME;
export const RESULT_SUMMARY_V4_CARD = ResultSummaryV4I.CARD_NAME;
export const RESULT_SUMMARY_ACTIONS = ResultSummaryV4I.ACTIONS;
export const RESULT_SUMMARY_V4_BTN_ACTS = ResultSummaryV4I.BTN_ACTS;

export type ResultSummaryV4SequenceState = ResultSummaryV4I.State["ResultSummaryV4Sequence"];
export type ResultSummaryV4ActionName = ResultSummaryV4I.ActionName;
export type ResultSummaryRunParams = ResultSummaryV4I.ResultRunParams;
export type ResultSummaryRunSequenceProp = ResultSummaryV4I.ResultRunSequenceProp;
export type ResultSummaryV4Event = ResultSummaryV4I.Event;
export type ResultSummaryV4State = ResultSummaryV4I.State;
export type ResultSummaryV4Data = ResultSummaryV4I.Data;

export const resultBtnKey = ResultSummaryV4I.resultBtnKey;
export const resultErrorKey = ResultSummaryV4I.resultErrorKey;

export { ResultSummaryV4I };

/* ============================================================== */
/*   PatientHistoryV4 (หน้า Patient History Viewer · 4d)          */
/* ============================================================== */

export const PATIENT_HISTORY_V4_SEQUENCE = PatientHistoryV4I.SEQUENCE_NAME;
export const PATIENT_HISTORY_V4_CARD = PatientHistoryV4I.CARD_NAME;
export const PATIENT_HISTORY_ACTIONS = PatientHistoryV4I.ACTIONS;
export const PATIENT_HISTORY_V4_BTN_ACTS = PatientHistoryV4I.BTN_ACTS;

export type PatientHistoryV4SequenceState = PatientHistoryV4I.State["PatientHistoryV4Sequence"];
export type PatientHistoryV4ActionName = PatientHistoryV4I.ActionName;
export type PatientHistoryRunParams = PatientHistoryV4I.HistoryRunParams;
export type PatientHistoryRunSequenceProp = PatientHistoryV4I.HistoryRunSequenceProp;
export type PatientHistoryV4Event = PatientHistoryV4I.Event;
export type PatientHistoryV4State = PatientHistoryV4I.State;
export type PatientHistoryV4Data = PatientHistoryV4I.Data;

export const patientHistoryBtnKey = PatientHistoryV4I.historyBtnKey;
export const patientHistoryErrorKey = PatientHistoryV4I.historyErrorKey;

export { PatientHistoryV4I };

/* ------------------------------------------------------ */

/*   RegistrationV4 (ระดับสมาชิกของหน้า Search Member)      */

/* ------------------------------------------------------ */

export type RegistrationV4SequenceState = RegistrationV4I.State["RegistrationV4Sequence"];

export { RegistrationV4I };

/* ------------------------------------------------------ */

/*   TeleHealthV4 (นัด telemed · ข้อความสำเร็จรูป · ไฟล์ในห้องแชท) */

/* ------------------------------------------------------ */

export type TeleHealthV4SequenceState = TeleHealthV4I.State["TeleHealthV4Sequence"];

export { TeleHealthV4I };

/* ------------------------------------------------------ */

/*   PackageV4 (หน้า Package ของผู้ป่วย)                    */

/* ------------------------------------------------------ */

export type PackageV4SequenceState = PackageV4I.State["PackageV4Sequence"];

export { PackageV4I };

/* ------------------------------------------------------ */

/*     QUEUE DOMAIN (ไฟล์ pure ./queueDomainV4 — ไม่มี SDK)        */
/*     CardPatientListV4 / CardOrdersV4 / MainHISV4 ใช้จากที่นี่     */

/* ------------------------------------------------------ */

export type QueueEncounter = QueueDomainI.QueueEncounter;
export type QueueStage = QueueDomainI.QueueStage;
export type QueueStageKey = QueueDomainI.QueueStageKey;
export type OrderKind = QueueDomainI.OrderKind;
export type OrderState = QueueDomainI.OrderState;
export type QueueFilter = QueueDomainI.FilterType;
export type QueueUiFilter = QueueDomainI.UiFilterType;

export const APPOINT_FORMAT = QueueDomainI.APPOINT_FORMAT;
export const QUEUE_STAGES = QueueDomainI.QUEUE_STAGES;
export const ORDER_KIND_LABELS = QueueDomainI.ORDER_KIND_LABELS;
export const ORDER_STATE_LABELS = QueueDomainI.ORDER_STATE_LABELS;

export const stageOf = QueueDomainI.stageOf;
export const orderGroups = QueueDomainI.orderGroups;
export const orderKindOf = QueueDomainI.orderKindOf;
export const createdText = QueueDomainI.createdText;
export const appointText = QueueDomainI.appointText;
export const waitText = QueueDomainI.waitText;

/* ------------------------------------------------------ */

/*                    Main HISV4 common                   */

/* ------------------------------------------------------ */

export type Props = {} & PatientListV4I.Props;

export type State = {
  masterOptions?: any;
  errorMessage?: any;
  successMessage?: any;
  buttonLoadCheck?: any; // {cardName: LOADING || SUCCESS || ERROR}
} & PatientListV4I.State &
  ExamV4I.State &
  PatientOrdersV4I.State &
  MultidisciplinaryV4I.State &
  OrderSheetV4I.State &
  OrderAppointmentV4I.State &
  ResultSummaryV4I.State &
  PatientHistoryV4I.State &
  RegistrationV4I.State &
  TeleHealthV4I.State &
  PackageV4I.State;

export const StateInitial: State = {
  masterOptions: {},
  errorMessage: {},
  successMessage: {},
  buttonLoadCheck: {},
  ...PatientListV4I.StateInitial,
  ...ExamV4I.StateInitial,
  ...PatientOrdersV4I.StateInitial,
  ...MultidisciplinaryV4I.StateInitial,
  ...OrderSheetV4I.StateInitial,
  ...OrderAppointmentV4I.StateInitial,
  ...ResultSummaryV4I.StateInitial,
  ...PatientHistoryV4I.StateInitial,
  ...RegistrationV4I.StateInitial,
  ...TeleHealthV4I.StateInitial,
  ...PackageV4I.StateInitial,
};

export type Event =
  | PatientListV4I.Event
  | ExamV4I.Event
  | PatientOrdersV4I.Event
  | MultidisciplinaryV4I.Event
  | OrderSheetV4I.Event
  | OrderAppointmentV4I.Event
  | ResultSummaryV4I.Event
  | RegistrationV4I.Event
  | TeleHealthV4I.Event
  | PackageV4I.Event;

export type Data = {
  division?: number;
  device?: number;
  masterData?: { [name: string]: any };
} & PatientListV4I.Data &
  ExamV4I.Data &
  PatientOrdersV4I.Data &
  MultidisciplinaryV4I.Data &
  OrderSheetV4I.Data &
  OrderAppointmentV4I.Data &
  ResultSummaryV4I.Data;

export const DataInitial = PatientListV4I.DataInitial;

/* ------------------------------------------------------ */

/*              props ของ card ที่ใช้หลาย sequence             */

/* ------------------------------------------------------ */

/** runSequence ของ sequence หลัก + เรียก sequence อื่นตามชื่อได้ */
export type MultiRunSequence<R, S extends string> = R &
  ((params: { sequence: S } & Record<string, any>) => void);

/** setProp ของ sequence หลัก + set key ใน state ของ sequence อื่นได้ */
export type MultiSetProp<P, K extends string> = P & ((key: `${K}.${string}`, value: any) => void);

/* ------------------------------------------------------ */

/*                        HELPERS                         */

/* ------------------------------------------------------ */

export const normalizePatientListV4Slice = PatientListV4I.normalizePatientListV4Slice;
export const emptyPatientListV4Slice = PatientListV4I.emptyPatientListV4Slice;
/** สำหรับ debug/test: key ของ buttonLoadCheck ต่อ action = PatientListV4I.patientListActionKey;

/** แปลง filter จาก UI -> params ของ API (from_date/to_date เป็น DD/MM/YYYY พ.ศ.) */
export const normalizePatientListV4Filter = QueueDomainI.NormalizeFilter;

/** แปลงวันที่เป็น DD/MM/YYYY (พ.ศ.) */
export const toBEDate = QueueDomainI.ToBEDate;

/** แปลงแถวจาก API -> แถวคิวสำหรับตาราง CardPatientListV4 */
export const toQueueEncounter = QueueDomainI.toQueueEncounter;
export const toQueueRows = QueueDomainI.toQueueRows;
